import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

const OVERRIDE_NS = 'override';

export function useTranslationWithOverride(ns?: string | string[])
{
    const namespaces = ns
        ? (Array.isArray(ns) ? ns : [ns])
        : ['translation'];

    const {t: originalT, ...rest} = useTranslation([...namespaces, OVERRIDE_NS]);

    const t = useCallback((key: string | string[], options?: Record<string, unknown>) => {
        const keys = Array.isArray(key) ? key : [key];
        const expandedKeys = keys.flatMap((k) =>
            k.includes(':') ? [k] : [`${OVERRIDE_NS}:${k}`, k]
        );
        return originalT(expandedKeys as [string, ...string[]], options);
    }, [originalT]) as typeof originalT;

    return {...rest, t};
}
